import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone, ArrowUp, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { BRAND } from "@/data/urban";
import { FLOATING } from "@/constants/testIds";

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const path = location.pathname;
  let contextMsg = "Hi Urban Renovations, I am interested in your interior and renovation services. I would like to discuss my requirement.";
  if (path.includes("modular-kitchen")) contextMsg = "Hi Urban Renovations, I would like a quote for a modular kitchen.";
  else if (path.includes("wardrobes")) contextMsg = "Hi Urban Renovations, I would like a quote for a wardrobe.";
  else if (path.includes("doors")) contextMsg = "Hi Urban Renovations, I would like a quote for designer doors.";
  else if (path.includes("home-renovation")) contextMsg = "Hi Urban Renovations, I would like a quote for home renovation.";
  else if (path.includes("home-interior")) contextMsg = "Hi Urban Renovations, I would like a quote for home interiors.";
  else if (path.includes("product/")) contextMsg = `Hi Urban Renovations, I'm interested in the product on this page (${window.location.href}).`;

  const waText = encodeURIComponent(contextMsg);

  return (
    <div className="fixed right-4 sm:right-6 bottom-24 sm:bottom-6 z-40 flex flex-col items-end gap-3">
      <AnimatePresence>
        {show && (
          <motion.button initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }}
            type="button" data-testid={FLOATING.scrollTop} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="h-11 w-11 rounded-full bg-black text-white shadow-xl flex items-center justify-center hover:bg-ink transition-colors" aria-label="Scroll to top">
            <ArrowUp className="h-5 w-5" />
          </motion.button>
        )}
      </AnimatePresence>
      <a href={`tel:${BRAND.phoneRaw}`} data-testid={FLOATING.call} className="hidden sm:flex h-12 w-12 rounded-full bg-black text-white shadow-xl items-center justify-center hover:bg-ink transition-colors" aria-label="Call">
        <Phone className="h-5 w-5" />
      </a>
      <a href={`https://wa.me/${BRAND.whatsapp}?text=${waText}`} target="_blank" rel="noopener noreferrer" data-testid={FLOATING.whatsapp} className="h-13 w-13 rounded-full bg-[#25D366] text-white shadow-xl flex items-center justify-center hover:bg-[#1FA855] transition-colors p-3" aria-label="WhatsApp">
        <MessageCircle className="h-5 w-5" />
      </a>
    </div>
  );
};
